import { withInstall } from '@zoryn/utils'
import InputTag from './src/input-tag.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZInputTag: SFCWithInstall<typeof InputTag> = withInstall(InputTag)
export default ZInputTag

export * from './src/input-tag'
export type { InputTagInstance } from './src/instance'
